<div #progressContainer class="progress-container">
  <svg class="progress-ring" width="120" height="120">
    <circle class="progress-ring__outer-circle" stroke-width="10" fill="transparent" cx="60" cy="60" />
    <circle class="progress-ring__circle" stroke-width="6" fill="transparent" cx="60" cy="60" />
    <text class="progress-ring__text" x="50" y="54%">{{percent}}%</text>
  </svg>
</div>
